import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { MenuService } from 'src/app/services/menu.service';
import { PdfService } from 'src/app/services/pdf.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { ActivatedRoute } from '@angular/router';
import { ResizedEvent } from 'angular-resize-event';
import { BillingInvoiceEditService } from '../../../services/billing/billing-invoice/billing-invoice-edit.service';

@Component({
  selector: 'app-billing-invoive-view',
  templateUrl: './billing-invoive-view.component.html',
  styleUrls: ['./billing-invoive-view.component.css']
})
export class BillingInvoiveViewComponent implements OnInit {

  loading: boolean;
  safeResourceUrl: SafeResourceUrl;
  widthExp = 800;
  heightExp = 800;
  @Input() billingInvoiceId: number;
  @Output() close = new EventEmitter();

  constructor(private billingInvoiceEditService: BillingInvoiceEditService
    , private menuService: MenuService
    , private pdfService: PdfService
    , private notificationToastService: NotificationToastService) {
    this.menuService.setMenuTitle('Facturación', 'Entidad');
  }

  async ngOnInit() {
    await this.showPdf();
  }

  private async showPdf() {
    try {
      this.loading = true;
      if (this.billingInvoiceId) {
        const invoiceCashDesk = await this.billingInvoiceEditService.getBillingInvoiceReport(this.billingInvoiceId);
        const pdfUrl = this.pdfService.base64ToPdfUrl(invoiceCashDesk.ReportBase64);
        this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Generación factura');
    }
    finally {
      this.loading = false;
    }
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
    this.heightExp = event.newHeight;
  }
}
